import { standardization } from "./standardization.ts";
import { digitalization } from "./digitalization.ts";
import { automation } from "./automation.ts";
import { ai } from "./ai.ts";

import type { ChecklistSectionConfig } from "../types.ts";

export const CHECKLIST_SECTIONS: ChecklistSectionConfig[] = [
  standardization,
  digitalization,
  automation,
  ai,
];

